import {IAirBridge} from '../services/IAirBridge';
import {IPostAction} from './IPostAction';

export class NativeSubscriptionsDialogAction implements IPostAction {
    constructor(private airBridge: IAirBridge) {
    }
    public execute(): void {
        const uuid = Date.now().toString(10) + Math.random();
        this.airBridge.evoke(`invokeFn({"name":"nativeSubscriptionsDialog","uuid":"${uuid}","args":[]})`);
    }
}


